import React, { useEffect } from 'react'
import { gql, useQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { Row, Select } from 'antd'
import CentredLoader from '../../../../components/CentredLoader'
import { ProductType } from '../../../../types/index'

const MAIL_SERVICES = gql`
  query getMailServices($countryConfigId: ID!) {
    mailServices(countryConfigId: $countryConfigId) {
      id
      title
      activated
    }
  }
`

interface Props {
  countryConfigId: string | undefined
  field: any
  form: any
  setEstimationVariables: any
  estimationVariables: any
  readOnlyForm: boolean
}

const MailOptions = (props: Props): JSX.Element => {
  const { t } = useTranslation()
  const { loading: loadingMailServices, data: dataMailServices } = useQuery(
    MAIL_SERVICES,
    {
      fetchPolicy: 'no-cache',
      variables: { countryConfigId: props.countryConfigId },
    }
  )

  const selectedOptionIsInclude = dataMailServices?.mailServices
    ?.map((item: ProductType) => {
      return item.id
    })
    ?.includes(props.field.value)
  let defaultValue
  if (selectedOptionIsInclude) defaultValue = props.field.value

  useEffect(() => {
    if (!!dataMailServices && !selectedOptionIsInclude) {
      props.form.setFieldValue(props.field.name, undefined)
      props.setEstimationVariables({
        ...props.estimationVariables,
        mailServiceId: undefined,
      })
    }
  }, [dataMailServices])

  if (loadingMailServices) return <CentredLoader />

  const { mailServices } = dataMailServices

  const { Option } = Select

  return (
    <React.Fragment>
      <Row>
        <label>{t('mailServices.label')}</label>
      </Row>
      <Row>
        <Select
          disabled={props.readOnlyForm}
          defaultValue={defaultValue}
          onChange={e => {
            props.form.setFieldValue(props.field.name, e)
            props.setEstimationVariables({
              ...props.estimationVariables,
              mailServiceId: e,
            })
          }}
          style={{ width: '250px' }}
        >
          {mailServices.map((item: ProductType) => {
            return (
              <Option key={item.id} value={item.id} disabled={!item.activated}>
                {item.title}
              </Option>
            )
          })}
        </Select>
      </Row>
    </React.Fragment>
  )
}

export default MailOptions
